export const DEFAULT_LOCALE = 'en-US';

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = 'pages.homepage';
export const NAV_MESSAGE_BUNDLE_NAME = 'pages.nav';

export const AWS_SKILL_BUILDER_LINK =
  'https://skillbuilder.aws/?tk=ced64b47-4bea-46e1-ba6d-d1740f5b5a22&sc_channel=el';
export const AWS_SKILLS_CENTER_LINK =
  'https://aws.amazon.com/training/skills-centers/?trk=a88368a1-3e46-41dd-9a68-e094e6e77ca9&sc_channel=el';
export const AWS_RESTART_LINK =
  'https://aws.amazon.com/training/restart/?trk=8cfa5f3e-cac2-491a-a419-83645bc4fde2&sc_channel=el';
export const AMAZON_PRIME_LINK =
  'https://www.aboutamazon.com/news/retail/amazon-prime-access-discounted-membership';
export const AMAZON_PHARMACY_LINK = 'https://pharmacy.amazon.com/';
export const ONE_MEDICAL_LINK = 'https://www.onemedical.com/';
export const SUPPLIER_CONNECT_LINK = 'https://supplierconnect.amazon.com/';
export const AMAZON_LITERARY_LINK =
  'https://www.aboutamazon.com/news/books-and-authors/apply-now-for-this-years-amazon-literary-partnership-grants';
export const AMAZON_VOLUNTEERING_LINK =
  'https://www.aboutamazon.com/news/community/amazon-global-volunteering';
export const CAREERS_LINK = 'https://share.google/lGLyTyS4nfqzYwAVB';
export const CONDITIONS_OF_USE_LINK =
  'https://www.amazon.com/gp/help/customer/display.html?nodeId=508088';
export const PRIVACY_NOTICE_LINK =
  'https://www.amazon.com/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ&ref_=footer_privacy';
